<owc-modal-dialog #internetStatus disable-backdrop-click="true" class="internetStatusModal" size="small">    
    <owc-component-header slot="header">
        <owc-typography variant="title5" element="h5">Internet connection status</owc-typography>
    </owc-component-header>
    <owc-typography variant="body1" element="p" >
        {{connectionStatusMessage}}
    </owc-typography> 
  </owc-modal-dialog>
<router-outlet></router-outlet>